import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

interface HeaderProps {
  readonly index: number;
  readonly children: ReactNode;
  readonly className?: string;
}

function getTextColor(index: number) {
  if (index === 0 || index === 6) {
    return 'text-red-500';
  }

  return 'text-neutral-700';
}

function Header({ index, children, className }: HeaderProps) {
  const classes = twMerge('mb-1.5 mt-1 h-8 w-10 text-center capitalize leading-8', getTextColor(index), className);

  return <h6 className={classes}>{children}</h6>;
}

export { Header };
